import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import {Input} from 'antd'
import {EnvironmentFilled} from '@ant-design/icons'
import Heading from 'components/shared/Heading'
import SearchResult from './SearchResult'

const THROTTLE_DELAY = 1000

let searchThrottle

const AddressSearch = ({onSelect, tabs, initialSearch = '', selectedAddress}) => {
  const [currentInput, setCurrentInput] = useState(initialSearch)
  const [address, setAddress] = useState('')

  const performSearch = (query) => {
    clearTimeout(searchThrottle)
    searchThrottle = setTimeout(() => setAddress(query), THROTTLE_DELAY)
  }

  const searchFieldUpdated = (evt) => {
    const value = evt.target.value
    setCurrentInput(value)
  }

  const addressSelected = (address) => {
    onSelect(address)
  }

  const geoLocate = () => {
    // TODO
  }

  useEffect(() => {
    if (currentInput) {
      performSearch(currentInput)
    }
  }, [currentInput])

  return (
    <div className="address-search">
      <Heading level={3}>Adressesøk</Heading>

      <div className="input-group">
        <Input
          size="large"
          placeholder="Gateadresse"
          value={currentInput}
          onChange={searchFieldUpdated}
          suffix={
            <EnvironmentFilled onClick={geoLocate} />
          }
        />

        {tabs}
      </div>

      {!!address.length && (
        <SearchResult
          partialStreetName={address}
          onSelect={addressSelected}
          selectedAddress={selectedAddress}
        />
      )}
    </div>
  )
}

AddressSearch.propTypes = {
  onSelect: PropTypes.func,
}

export default AddressSearch
